import type { FC } from 'react'
import { IncidentsReportMainScreen } from 'screens/Reports/Incidents'
import styled from 'styled-components'
import { GroupsSidebarNavigation } from '../components'

const IncidentsReports: FC = () => {
  return (
    <div style={styles.mainContainer}>
      <StyledNavigation>
        <GroupsSidebarNavigation />
      </StyledNavigation>
      <StyledInnerContainer>
        <IncidentsReportMainScreen
          hasResidentsFilter={false}
          hasHomesFilter
          hasSeverityFilter={false}
          hasOnClick={false}
        />
      </StyledInnerContainer>
    </div>
  )
}

const styles = {
  mainContainer: {
    display: 'flex',
    height: 'calc(100vh - 64px)',
    maxWidth: '2000px'
  }
}

const StyledInnerContainer = styled.div`
  height: calc(100vh - 64px);
  overflow-y: auto;
  width: 100%;
`

const StyledNavigation = styled.div`
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    display: none;
  }
`

export default IncidentsReports
